export const SKIP_CONFIRMATION_EXIT_ONCE_EVENT = "don't show confirmation before exit"

export const dispatchSkipShowConfirmationExitOnceEvent = () => {
  const event = new Event(SKIP_CONFIRMATION_EXIT_ONCE_EVENT)
  window.dispatchEvent(event)
}
